import React from 'react'
import PropTypes from 'prop-types'
import Image from '../image'
import TextWithHighlights from './text-with-highlights'
import SearchRow from './search-row'
import style from './index.module.scss'

const SearchResult = ({
  href,
  hit,
  imageUrl,
  highlightField,
  secondaryHighlightedContent,
  description,
  noImage,
  className,
  onClick,
}) => (
  <SearchRow
    href={href}
    key={hit.objectID}
    className={className}
    target={hit.isNewTab ? '_blank' : '_self'}
    onClick={onClick}
  >
    {!noImage && (
      <Image
        className={style.searchImage}
        imageUrl={imageUrl}
        ratio="square"
        bgSize="contain"
      />
    )}
    <TextWithHighlights hit={hit} field={highlightField} />
    {secondaryHighlightedContent && (
      <div className={style.textWithHighlights}>
        {secondaryHighlightedContent}
      </div>
    )}
    {description && <div className={style.description}>{description}</div>}
  </SearchRow>
)

SearchResult.propTypes = {
  href: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  highlightField: PropTypes.string.isRequired,
  secondaryHighlightedContent: PropTypes.string,
  description: PropTypes.string,
  hit: PropTypes.object.isRequired,
  noImage: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
}

SearchResult.defaultProps = {
  noImage: false,
}

export default SearchResult
